import { render, staticRenderFns } from "./DepartmentRoot.vue?vue&type=template&id=2519206a&scoped=true"
import script from "./DepartmentRoot.vue?vue&type=script&lang=ts"
export * from "./DepartmentRoot.vue?vue&type=script&lang=ts"
import style0 from "./DepartmentRoot.vue?vue&type=style&index=0&id=2519206a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2519206a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
